import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const ProtectedRoutes = ({ isUser }) => {
    return <div>{isUser ? <Outlet /> : <Navigate to="/" />}</div>;
};

export default ProtectedRoutes;
